/** @jsxImportSource @emotion/react */
import { formatCalendarDate } from 'helpers/dates'
import type { DeviceShelfLifeInfo } from 'store/types'

interface IProps {
  device: {
    expirationDate?: string | null
    shelfLife?: DeviceShelfLifeInfo | null
  }
}

// TES-3191: when a tracked device must leave service, flagged once it is close or past.
export const ExpirationCell = ({ device }: IProps) => {
  const { shelfLife, expirationDate } = device

  if (!shelfLife) return <>—</>

  if (!expirationDate) {
    return (
      <span className="text-muted" title="The shelf life starts at the first check-out">
        Not started
      </span>
    )
  }

  return (
    <span className="text-nowrap">
      {formatCalendarDate(expirationDate)}
      {shelfLife.expired && (
        <i
          className="fas fa-exclamation-circle ml-1"
          css={{ color: '#dc3545' }}
          title="Expired"
          aria-label="Expired"
        />
      )}
      {!shelfLife.expired && shelfLife.expiringSoon && (
        <i
          className="fas fa-hourglass-half ml-1"
          css={{ color: '#f0ad4e' }}
          title="Expires within 30 days"
          aria-label="Expires within 30 days"
        />
      )}
    </span>
  )
}
